"use client"
"use client";
import {
  checkbox_default
} from "../chunk-ASV3IKCU.js";
import {
  getPropByString
} from "../chunk-Q2O3JHTB.js";

// src/checkbox/checkbox-field.tsx
import {
  useFormContext,
  useFormState
} from "react-hook-form";
import { jsx } from "react/jsx-runtime";
var CheckboxField = (props) => {
  const { register } = useFormContext();
  const { errors } = useFormState();
  const error = getPropByString(errors, props.name);
  const { ref, ...registerRest } = register(props.name, props.rules);
  return /* @__PURE__ */ jsx(checkbox_default, { ...registerRest, ref, ...props, error: error?.message });
};
var checkbox_field_default = CheckboxField;
export {
  checkbox_field_default as default
};
